<template>
  <InputRadioGroup
    v-model="themeMode"
    :options="themeOptions"
  />
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useDarkMode } from '@/composables/useDarkMode'
  import InputRadioGroup from './InputRadioGroup.vue'

  const { themeMode } = useDarkMode()

  const themeOptions = computed(() => [
    {
      name: 'light',
      iconName: 'pi-sun',
      label: 'Light mode'
    },
    {
      name: 'system',
      iconName: 'pi-desktop',
      label: 'System mode'
    },
    {
      name: 'dark',
      iconName: 'pi-moon',
      label: 'Dark mode'
    }
  ])
</script>

<style scoped>
.theme-toggle {
  position: relative;
}
</style>
